import { useState } from "react";

export default function PasswordGate({ children }) {
  const [input, setInput] = useState("");
  const [ok, setOk] = useState(false);

  const password = process.env.REACT_APP_PASSWORD;

  // If no password set (local dev), skip protection
  if (!password) return children;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === password) setOk(true);
  };

  if (ok) return children;

  return (
    <div style={{ padding: 50, textAlign: "center" }}>
      <h2>Enter Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          type="password"
          placeholder="Password"
        />
        <button type="submit">Enter</button>
      </form>
    </div>
  );
}
